function initNewsletterSection() {

  if($('#neos-application').length) {} else {
    $('.newsletter-section').each(function() {
      $(this).find('.newsletter-form > .elem-1').one('click touchend','button',function(e) {
        $('.parallax-mirror').css("display","none");
        $('.newsletter-form').css("height","510px");
        var elem = $(this).parents('.newsletter-form');
        $(elem).find('.elem-1').hide(200);
        $(elem).find('.elem-2').show(100);
        setTimeout(function() {
          $(elem).find('.elem-2 form').one('submit',function(e) {
            $('.parallax-mirror').css("display","block");
            $('.newsletter-form').css("height","auto");
            var elem = $(this).parents('.newsletter-form');
            $(elem).find('.elem-2').hide(200);
            $(elem).find('.elem-3').show(100);
          });
        },500);
      });
    });
  }
}
